var map = {
	"./coletor.": "8692",
	"./coletor.svg": "8692",
	"./confirmacao.": "1459",
	"./confirmacao.svg": "1459",
	"./entrada.": "9c13",
	"./entrada.svg": "9c13",
	"./logo-colorido.": "f986",
	"./logo-colorido.png": "f986",
	"./logo-mindsight.": "728a",
	"./logo-mindsight.svg": "728a",
	"./logo-sankhya.": "3e26",
	"./logo-sankhya.svg": "3e26",
	"./novo-favicon.": "7753",
	"./novo-favicon.png": "7753",
	"./pausa.": "a1ee",
	"./pausa.svg": "a1ee",
	"./pontotel-branco.": "795f",
	"./pontotel-branco.png": "795f",
	"./pontotel-novo-branco.": "3d85",
	"./pontotel-novo-branco.png": "3d85",
	"./retorno.": "97d5",
	"./retorno.svg": "97d5",
	"./saida.": "72f7",
	"./saida.svg": "72f7",
	"./sem-historico.": "eed1",
	"./sem-historico.svg": "eed1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56d1";